/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RefreshReservationCreditPurchasePathParameters } from 'api/actions/refresh-reservation-credit-purchase/refresh-reservation-credit-purchase-path-parameters';
import { RefreshReservationCreditPurchaseResponse } from 'api/actions/refresh-reservation-credit-purchase/refresh-reservation-credit-purchase-response';

type RefreshReservationCreditPurchaseQueryParameters = Record<string, any>;

/**
 * The path of the RefreshReservationCreditPurchase action.
 */
export const refreshReservationCreditPurchaseActionPath = new SweetPath<
  keyof RefreshReservationCreditPurchasePathParameters
>('/reservations/credits/purchases/{purchaseId}/refresh', { path: '{param}' });

/**
 * Creates a contextualized RefreshReservationCreditPurchase actions.
 */
export default function createRefreshReservationCreditPurchaseAction(axios: AxiosInstance) {
  return function refreshReservationCreditPurchaseAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RefreshReservationCreditPurchasePathParameters;
    query?: RefreshReservationCreditPurchaseQueryParameters;
  }) {
    const path = refreshReservationCreditPurchaseActionPath.insert(parameters);

    return axios.post<RefreshReservationCreditPurchaseResponse, RefreshReservationCreditPurchaseResponse>(path, {
      params: query,
      headers,
    });
  };
}
